import React from 'react';
import logo200Image from '../assets/img/logo/20200723_UnitySuiteSqLogo512.webp';
import unsubscribeImage from '../assets/img/logo/email-2.png';
import checkedImage from '../assets/img/logo/checked.png';
import { Button, Spinner, Card, CardHeader, CardBody } from 'reactstrap';
import axios from 'axios';
import { Redirect } from 'react-router';
import StorageService from '../services/StorageService';
import queryString from 'query-string';
import Helmet from 'react-helmet';
const app_year = process.env.REACT_APP_YEAR;
const app_name = process.env.REACT_APP_NAME;

class VerifyUserPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      unsubscribe: false,
      email: '',
      customer_id: '',
      company_id: '',
      isID: '',
    };
  }

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    if (params.id) {
      this.setState({
        customer_id: params.id,
        isID: true,
      });
      this.CustomerDetail(params.id);
    }

    if (params.email) {
      this.setState({
        email: params.email,
        company_id: params.company_id,
        isID: false,
      });
    }
  }

  CustomerDetail(customer_id) {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      customer_id: customer_id,
    };
    axios
      .post(url + ':3004/v1/customer/detail', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({
          email: result.data.email,
          unsubscribe: result.data.dnd,
          submit: result.data.dnd ? true : false,
        });
      })
      .catch(error => {
        alert(error);
      });
  }

  Unsubscribe(dnd) {
    const user = StorageService.getSession('user_info');
    const comp = StorageService.getSession('selected_org');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      customer_id: this.state.customer_id,
      dnd: dnd ? '1' : '0',
      updated_by: this.state.email,
    };
    axios
      .post(url + ':3004/v1/customer/detail/dnd', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({
          unsubscribe: true,
          submit: true,
        });
      })
      .catch(error => {
        alert(error);
      });
  }

  Unsubscribe_v2() {
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_UNITY_API2_URL;
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: this.state.company_id,
      email: this.state.email,
      updated_by: this.state.email,
    };
    axios
      .post(url + ':3004/v1/customer/campaign/unsubscribe', data)
      .then(response => {
        const result = response.data;
        if (result.error == true && result.message != 'Success') {
          alert(result.message);
          return;
        }
        this.setState({
          unsubscribe: true,
          submit: true,
        });
      })
      .catch(error => {
        alert(error);
      });
  }

  handleSubmit() {
    if (this.state.isID) {
      this.Unsubscribe(true);
    } else {
      this.Unsubscribe_v2();
    }
  }

  render() {
    const { submit, unsubscribe } = this.state;

    return (
      <div className="unsubscribe">
        <Helmet>
          <title>Cancel Your Subscription</title>
        </Helmet>
        <div className="wrapper text-center">
          <Card>
            <CardHeader>
              <img src={logo200Image} className="logo" alt="logo" />
              <h1>
                <span>Unity</span>
                <span>SuitePro</span>
              </h1>
            </CardHeader>
            <CardBody>
              <h3>
                {submit && unsubscribe
                  ? 'Unsubscribe Successful'
                  : 'Unsubscribe'}{' '}
              </h3>
              <div className="unsubscribe-logo">
                <img src={unsubscribeImage} />
                {submit && unsubscribe && (
                  <img src={checkedImage} className="success-unsubscribe" />
                )}
              </div>
              <p>
                {submit && unsubscribe
                  ? 'You have successfully unsubscribed, you will no longer receive this type of emails from us.'
                  : 'Are you sure you wish to unsubscribe from our emails?'}
              </p>

              {!submit && !unsubscribe && (
                <div className="button-group">
                  <Button
                    className="theme-button theme-button-secondary"
                    onClick={() => this.handleSubmit()}
                  >
                    Confirm
                  </Button>
                </div>
              )}
            </CardBody>
          </Card>
          <br />
          <small className="text-muted">
            Copyright © 2020-{app_year} {app_name}. All Rights Reserved.
          </small>
        </div>
      </div>
    );
  }
}
export default VerifyUserPage;
